import { render, staticRenderFns } from "./BuscarInstitucion.vue?vue&type=template&id=34b06d32&scoped=true"
import script from "./BuscarInstitucion.vue?vue&type=script&lang=js"
export * from "./BuscarInstitucion.vue?vue&type=script&lang=js"
import style0 from "./BuscarInstitucion.vue?vue&type=style&index=0&id=34b06d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b06d32",
  null
  
)

export default component.exports